module.exports = __webpack_public_path__ + "static/christmas-trees-3b975758796ec166854b81698846d99d.gif";